<template>
    <div class="padding ds-index-container">
        <div class="vc-index-nav ds-nav">
            <i class="fa fa-home margin-right-sm"></i>
            <span>首页</span>
            <span class="margin-left-sm margin-right-sm">/</span>
            <span class="ds-nav-current">开发中心</span>
        </div>
        <el-row :gutter="20" class="ds-metrics-row">
            <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4" class="margin-bottom" v-for="(item, index) in datas" :key="index">
                <div class="ds-metric-card">
                    <div class="ds-metric-value" :style="{ 'color': getColor(index) }">{{ item.value }}</div>
                    <div class="ds-metric-label">{{ item.name }}</div>
                </div>
            </el-col>
        </el-row>
        <el-row :gutter="20" class="ds-content-row">
            <el-col :xs="24" :lg="12">
                <div class="ibox ds-ibox">
                    <div class="ibox-title">
                        <i class="el-icon-menu margin-right-sm"></i>常用功能
                    </div>
                    <div class="ibox-content">
                        <el-row class="white-bg padding margin-xs ds-features-row">
                            <el-col :xs="12" :sm="8" :md="6" class="text-center margin-top margin-bottom" style="cursor:pointer"
                                v-for="(item, index) in pages" :key="index">
                                <div @click="newFlow(item)" class="ds-feature-item">
                                    <div class="ds-feature-icon">
                                        <img :src="item.icon" />
                                    </div>
                                    <div class="ds-feature-name margin-top-sm">
                                        <span>{{ item.name }}</span>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </el-col>
            <el-col :xs="24" :lg="12">
                <div class="ds-chart-container">
                    <div ref="chartDom" style="height:380px;" class="ds-chart"></div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
  
<script>
import { queryDevCount, queryAppServiceData } from '@/api/user/indexApi'
import * as echarts from 'echarts'
export default {
    name: 'indexDev',
    components: {

    },
    data() {
        return {
            datas: [],
            action: '',
            pages: [{
                name: '应用',
                url: '/#/pages/dev/appManage?tab=应用信息',
                icon: '/img/app.png'
            }, {
                name: '服务',
                url: '/#/pages/dev/serviceManage?tab=服务信息',
                icon: '/img/api.png'
            }, {
                name: '服务注册',
                url: '/#/pages/dev/serviceRegisterManage?tab=服务注册',
                icon: '/img/register.png'
            }, {
                name: '菜单维护',
                url: '/#/pages/dev/menuManage?tab=菜单维护',
                icon: '/img/menu.png'
            }, {
                name: '配置中心',
                url: '/#/pages/dev/mappingManage?tab=配置中心',
                icon: '/img/config.png'
            }, {
                name: '刷新缓存',
                url: '/#/pages/dev/cacheManage?tab=刷新缓存',
                icon: '/img/cache.png'
            }, {
                name: '定时任务',
                url: '/#/pages/dev/jobManage?tab=定时任务',
                icon: '/img/job.png'
            }],
        }
    },
    created() {
        this._loadData()
        this._loadAppServiceData()
    },
    methods: {
        getColor(index) {
            const colors = ['#1acda1', '#ffae11', '#ff7911', '#3a68f2'];
            return colors[index % 4];
        },
        newFlow(item) {
            console.log(item)
            let _url = item.url.replace('#/', '')
            this.$router.push(_url)
        },
        async _loadData() {
            this.loading = true
            try {
                const _json = await queryDevCount()
                for (let _index = 0; _index < _json.data.length; _index++) {
                    if (_index % 4 == 0) {
                        _json.data[_index].color = "#1acda1";
                    }
                    if (_index % 4 == 1) {
                        _json.data[_index].color = "#ffae11";
                    }
                    if (_index % 4 == 2) {
                        _json.data[_index].color = "#ff7911";
                    }
                    if (_index % 4 == 3) {
                        _json.data[_index].color = "#3a68f2";
                    }
                }
                this.datas = _json.data;
            } catch (error) {
                console.error('登录失败：', error)
            } finally {
                this.loading = false
            }
        },
        async _loadAppServiceData() {
            this.loading = true
            try {
                const _json = await queryAppServiceData()
                this._initDevIndexAppServiceCharts(_json.data)
            } catch (error) {
                console.error('登录失败：', error)
            } finally {
                this.loading = false
            }
        },
        _initDevIndexAppServiceCharts: function (_data) {
            const chartDom = this.$refs.chartDom
            let _source = [
                ['product', '接口数'],
            ];

            _data.forEach(item => {
                _source.push([
                    item.name,
                    item.serviceCount,
                ])
            });

            let myChart = echarts.init(chartDom);
            let option = null;
            option = {
                legend: {},
                tooltip: {},
                title: {
                    show: "true",
                    text: '应用接口数',
                    textStyle: {
                        color: '#003434',
                        fontWeight: '600'
                    }
                },
                color: ['#003434', '#004d4d', '#66CDAA', '#735c00'],
                dataset: {
                    source: _source
                },
                xAxis: { type: 'category' },
                yAxis: {},
                series: [
                    { type: 'bar' }
                ]
            };

            if (option && typeof option === "object") {
                myChart.setOption(option, true);
            }

        },
    }
}
</script>
  
<style lang="scss" scoped>
.ds-index-container {
  background: linear-gradient(135deg, var(--ds-gray-100) 0%, white 100%);
  min-height: calc(100vh - 60px);
}

.ds-nav {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: var(--ds-gray-700);

  i {
    color: var(--ds-primary);
  }

  .ds-nav-current {
    color: var(--ds-primary);
    font-weight: 600;
  }
}

.ds-metrics-row {
  margin-bottom: var(--ds-spacing-lg);
}

.ds-metric-card {
  background: white;
  border-radius: var(--ds-radius-lg);
  border: 1px solid var(--ds-gray-300);
  padding: 20px 15px;
  text-align: center;
  min-height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  box-sizing: border-box;
}

.ds-metric-value {
  font-size: 32px;
  font-weight: 700;
  line-height: 1.2;
  word-break: break-all;
  text-align: center;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ds-metric-label {
  font-size: 14px;
  color: var(--ds-gray-600);
  margin-top: 8px;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.ds-content-row {
  margin-top: var(--ds-spacing-lg);
}

.ds-ibox {
  height: 100%;
}

.ds-features-row {
  border-radius: var(--ds-radius-md);
}

.ds-feature-item {
  padding: var(--ds-spacing-md);
  border-radius: var(--ds-radius-md);
  transition: background-color var(--ds-transition-fast),
              transform var(--ds-transition-fast);

  &:hover {
    background-color: rgba(var(--ds-primary-rgb), 0.05);
    transform: scale(1.05);
  }
}

.ds-feature-icon {
  width: 50px;
  height: 50px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--ds-gray-100);
  border-radius: var(--ds-radius-lg);
  transition: background-color var(--ds-transition-fast);
}

.ds-feature-icon img {
  width: 28px;
  height: 28px;
  object-fit: contain;
}

.ds-feature-name {
  color: var(--ds-gray-700);
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ds-chart-container {
  background: white;
  border-radius: var(--ds-radius-lg);
  border: 1px solid var(--ds-gray-300);
  padding: var(--ds-spacing-lg);
  height: 100%;
  min-height: 420px;
  box-shadow: var(--ds-shadow-sm);
}

.ds-chart {
  width: 100%;
  height: 100%;
}

.vc-index-nav {
  padding: 10px;
  font-size: 16px;
  text-align: left;
}
</style> 